/**
 * Created by fers on 25.10.16.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {LoadingLine} from '../loadingLine/renderLoadingPanel.react';

import './LoadingButton.scss';

/**
 * An onClick handler may resolve with this value to report that the action did not complete
 * (cancelled, refused or failed and already reported). The button then stops loading without
 * showing the done check. Any other resolved value keeps the existing "done" behavior.
 */
export const LOADING_BUTTON_NOT_DONE = Object.freeze({ loadingButtonOutcome: 'not_done' });

interface LoadingButtonProps {
 className?: string;
 data?: string;
 disabled?: boolean;
 doneText?: any;
 icon?: string;
 iconObject?: object;
 isLoading?: boolean;
 onClick?: (...args: unknown[]) => unknown;
 onMouseOut?: (...args: unknown[]) => unknown;
 onMouseOver?: (...args: unknown[]) => unknown;
 progressText?: any;
 style?: object;
 text?: any;
 title?: string;
 type?: string;
 vertical?: boolean;
 withoutDone?: boolean;
}

export default class LoadingButton extends React.Component<LoadingButtonProps> {
    static propTypes = {
        className: PropTypes.string,
        data: PropTypes.string,
        disabled: PropTypes.bool,
        doneText: PropTypes.any,
        icon: PropTypes.string,
        iconObject: PropTypes.object,
        isLoading: PropTypes.bool,
        onClick: PropTypes.func,
        onMouseOut: PropTypes.func,
        onMouseOver: PropTypes.func,
        progressText: PropTypes.any,
        style: PropTypes.object,
        text: PropTypes.any,
        title: PropTypes.string,
        type: PropTypes.string,
        vertical: PropTypes.bool,
        withoutDone: PropTypes.bool,
    };

    static defaultProps = {
        style: {}
    };

    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            isDone: false,
            vertical: false,
            withoutDone: false,
        };
    }

    // The component *may* remove itself onClick and then trying to setState, which is void as the component no longer exists
    mounted = true;
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    setLoadingStateFalse = (done) => {
        if (this.mounted) {
            let newState = {
                isLoading: false
            };
            if (done !== undefined && !this.props.withoutDone) {
                newState.isDone = Boolean(done);
            }
            this.setState(newState);
        }
    };

    onClick = (e) => {
        if (this.props.disabled) {
            return false;
        }

        if (this.state.isLoading || this.props.isLoading) {
            return;
        }

        let f = this.props.onClick;

        if (f) {
            this.setState({
                isLoading: true,
                isDone: false,
            });

            try {
                return Promise.resolve(f(e)).then((result) => {
                    this.setLoadingStateFalse(result !== LOADING_BUTTON_NOT_DONE);
                }).catch((e) => {
                    this.setLoadingStateFalse();
                    throw e;
                });
            } catch (e) {
                this.setLoadingStateFalse();
                throw e;
            }
        }
    };


    render() {
        let elType = this.props.type === "button" || this.props.type === "submit" ? 'button' : 'div';
        let params = {
            className: this.props.className + " LoadingButton" + (this.props.vertical ? ' vertical' : ''),
            data: this.props.data,
            disabled: this.props.disabled,
            onClick: this.props.type !== "submit" ? this.onClick : null,
            onMouseOver: this.props.onMouseOver,
            onMouseOut: this.props.onMouseOut,
            style: {position: 'relative', ...this.props.style},
            title: this.props.title,
            type: this.props.type,
        };

        if (this.state.isLoading || this.props.isLoading) {
            params['style']['cursor'] = 'wait';
        }

        let isLoading = this.state.isLoading || this.props.isLoading;
        let icon = this.props.icon;
        let text = this.props.text;
        let iconObject = this.props.iconObject;

        if (icon) {
            iconObject = (<span className={"fa " + icon} />);
        }
        if (isLoading) {
            icon = "fa-spin fa-refresh";
            text = this.props.progressText || this.props.text;
            iconObject = (<span className="fa fa-spin fa-refresh" />);
        }
        if (this.state.isDone) {
            icon = "fa-check";
            text = this.props.doneText || this.props.text;
            iconObject = (<span className="fa fa-check" />);
            params.className += ' done';
        }
        let inner = <span>{isLoading ? <LoadingLine /> : null}{iconObject || null} <span className="text">{text}</span></span>;

        return React.createElement(elType, params, inner);
    }
}
